export default __webpack_public_path__ + "media/titles/title_3_locale_en-1630e1bc.png";